import { useNavigate } from "react-router-dom";
import { BookOpen, ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";
import ManualeOperatore from "../components/ManualeOperatore";

/**
 * Pagina dedicata al Manuale dell'Operatore, accessibile a tutti gli operatori
 * approvati (Allievi, Agenti, HR, Comando, Esecutiva). Serve come landing
 * diretta per il link presente nel promemoria Discord delle 20:00.
 */
export default function AreaManuale() {
  const navigate = useNavigate();
  return (
    <div className="space-y-6" data-testid="area-manuale">
      <div className="flex items-center gap-3">
        <Button
          onClick={() => navigate("/dashboard")}
          variant="outline"
          size="sm"
          data-testid="back-to-dashboard"
          className="border-sheriff-gold/40 text-sheriff-gold hover:bg-sheriff-gold/10 rounded-full uppercase-label"
        >
          <ArrowLeft className="h-4 w-4 mr-1" /> Indietro
        </Button>
        <div className="flex items-center gap-2 text-sheriff-gold">
          <BookOpen className="h-5 w-5" />
          <span className="font-heading font-bold text-xl text-[#F5E6B8]">Manuale dell&apos;Operatore</span>
        </div>
      </div>
      <ManualeOperatore />
    </div>
  );
}
